var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBullButterfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 43.9999V44.4999H7H30.793H31.1236L31.2531 44.1956L35.0785 35.202L41.5195 21.1569L48.5528 35.2235L48.691 35.4999H49H54H54.8164L54.4454 34.7727L41.9454 10.2727L41.4742 9.34912L41.0449 10.2929L29.9003 34.7929L29.8958 34.8031L27.6702 39.9999H7H6.5V40.4999V43.9999Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 44V44.5H7H30.793H31.1236L31.2531 44.1957L35.0812 35.1957L35.3771 34.5H34.6211H30.3555H30.0257L29.8958 34.8032L27.6702 40H7H6.5V40.5V44Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9999 44.5H52.675L52.543 44.2031L48.543 35.2031L48.2305 34.5H48.9999H53.9999H54.3219L54.4551 34.7931L56.8219 40H60.9999H61.4999V40.5V44V44.5H60.9999H52.9999Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullButterfly);
export default __webpack_public_path__ + "static/media/bull_butterfly.f5780051b161ab67f4325f29f0c73566.svg";
export { ForwardRef as ReactComponent };